// IELTS Mock 6 — Academic Writing (process diagram + two-part question essay)
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK6_WRITING = {
  title: "Academic Writing Practice Test 6",
  tasks: [
    {
      id: "task1",
      mock: 6,
      title: "Task 1: Report (20 min)",
      prompt:
        "The diagram below shows how seawater is converted into drinking water using reverse osmosis. Summarise the information by selecting and reporting the main features.",
      image: "/images/ielts-mock6/writing_task1_desalination.svg",
      minWords: 150,
      keywords: ["seawater", "intake", "screen", "pre-treatment", "filter", "pump", "pressure", "membrane", "reverse osmosis", "brine", "energy recovery", "mineral", "storage", "distribut", "stage", "process"],
      diagramType: "process"
    },
    {
      id: "task2",
      mock: 6,
      title: "Task 2: Essay (40 min)",
      prompt:
        "Never before has so much information been so freely available, yet some argue that people today are no better informed than previous generations. Why might this be the case? What can be done to address this problem?",
      minWords: 250,
      keywords: ["information", "internet", "inform", "knowledge", "misinformation", "social media", "critical thinking", "education", "source", "generation", "evaluat", "solution"]
    }
  ]
};

export default IELTS_MOCK6_WRITING;
